module.exports = "/_next/static/images/OgStateOfPersonalizationReport2023-0bdd7d61da6a23b2db316cf6766de28d.png";